/**Credentials of GCloud */
export const gcloudCredentials = {
  MAPS_API_KEY: "AIzaSyCM2f2EjxQ4jCOd_XiVg7yg1JNc79g2RQ4",
};
